// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function parseNumber(numberToBeParsed: string) {
  return parseInt(numberToBeParsed, 10) || 0;
}
